import React from 'react';
import { connect, Provider } from 'react-redux';
import styled from 'styled-components'
import { ConfigProvider } from 'antd';

const Portal = (props) => {
  return(
    <Provider store={props.store}>
      <ConfigProvider>
        <DashboardContainer>
          <DashboardRow>            
              {
                props.portal.widgets.map((component) => {
                  const {componentName, id, height, width, title} = component;
                  const Widget = window[componentName].default;

                  return (
                    <DashboardWidget key={id} width={width}>
                      <Widget id={id} isAdmin={props.isAdmin} height={height} title={title}></Widget>
                    </DashboardWidget>
                  )
                })
              }
          </DashboardRow>
        </DashboardContainer>
      </ConfigProvider>
    </Provider>
  )
}

const DashboardContainer = styled.div`
  height: calc(100vh - 50px);
  padding: 24px;
  overflow-y: auto;
  background-color: #efefef;
  .ant-table-container table > thead > tr th {
    background-color: #fff;
  }
`
const DashboardRow = styled.div`
  margin-left: -12px;
  margin-right: -12px;
  position: relative;
  box-sizing: border-box;
  ::before {
    display: table;
    content: '';
  }
`
const DashboardWidget = styled.div`
  float: left;
  padding-left: 12px;
  padding-right: 12px;
  box-sizing: border-box;
  width: ${ (p) => p.width }%;
  @media (max-width: 1000px) {
    width: 100%;
  }
`

const mapStateToProps = state => {
  const { portal } = state; 
  const { isAdmin } = state.user;

  return { isAdmin, portal };
};

export default connect(mapStateToProps)(Portal);